// ! AUTO-GENERATED FILE
// ! DO NOT TOUCH !!!

// #pause-sonar#
import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import {
  approveAllAutomatedRecourseBookings,
  ApproveAllAutomatedRecourseBookings$Params,
} from '../fn/recourse-booking/approve-all-automated-recourse-bookings';
import {
  approveRejectRecourseBooking,
  ApproveRejectRecourseBooking$Params,
} from '../fn/recourse-booking/approve-reject-recourse-booking';
import { cancelBooking, CancelBooking$Params } from '../fn/recourse-booking/cancel-booking';
import {
  createNewRecourseBooking,
  CreateNewRecourseBooking$Params,
} from '../fn/recourse-booking/create-new-recourse-booking';
import {
  getAllRecourseBookings,
  GetAllRecourseBookings$Params,
} from '../fn/recourse-booking/get-all-recourse-bookings';
import {
  getRecourseBookingDetails,
  GetRecourseBookingDetails$Params,
} from '../fn/recourse-booking/get-recourse-booking-details';
import {
  getRecourseBookingPendingApprovals,
  GetRecourseBookingPendingApprovals$Params,
} from '../fn/recourse-booking/get-recourse-booking-pending-approvals';
import {
  getRecourseBookingReferenceBookings,
  GetRecourseBookingReferenceBookings$Params,
} from '../fn/recourse-booking/get-recourse-booking-reference-bookings';
import {
  reprocessRecourseBooking,
  ReprocessRecourseBooking$Params,
} from '../fn/recourse-booking/reprocess-recourse-booking';
import { rewriteSignature, RewriteSignature$Params } from '../fn/recourse-booking/rewrite-signature';
import { setToBooked, SetToBooked$Params } from '../fn/recourse-booking/set-to-booked';
import { startApproval, StartApproval$Params } from '../fn/recourse-booking/start-approval';
import {
  startApprovalForAftersalesBookings,
  StartApprovalForAftersalesBookings$Params,
} from '../fn/recourse-booking/start-approval-for-aftersales-bookings';
import {
  startApprovalForNewRecourseBooking,
  StartApprovalForNewRecourseBooking$Params,
} from '../fn/recourse-booking/start-approval-for-new-recourse-booking';
import {
  updateRecourseBookingDetails,
  UpdateRecourseBookingDetails$Params,
} from '../fn/recourse-booking/update-recourse-booking-details';
import { RecourseBookingDto } from '../models/recourse-booking-dto';
import { StrictHttpResponse } from '../strict-http-response';

@Injectable({ providedIn: 'root' })
export class RecourseBookingService extends BaseService {
  /** Path part for operation `getRecourseBookingDetails()` */
  static readonly GetRecourseBookingDetailsPath = '/service/v1/recoursebooking/{recourseBookingId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRecourseBookingDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRecourseBookingDetails$Response(
    params: GetRecourseBookingDetails$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<RecourseBookingDto>> {
    return getRecourseBookingDetails(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRecourseBookingDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRecourseBookingDetails(
    params: GetRecourseBookingDetails$Params,
    context?: HttpContext,
  ): Observable<RecourseBookingDto> {
    return this.getRecourseBookingDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<RecourseBookingDto>): RecourseBookingDto => r.body),
    );
  }

  /** Path part for operation `updateRecourseBookingDetails()` */
  static readonly UpdateRecourseBookingDetailsPath = '/service/v1/recoursebooking/{recourseBookingId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRecourseBookingDetails()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRecourseBookingDetails$Response(
    params: UpdateRecourseBookingDetails$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<RecourseBookingDto>> {
    return updateRecourseBookingDetails(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRecourseBookingDetails$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRecourseBookingDetails(
    params: UpdateRecourseBookingDetails$Params,
    context?: HttpContext,
  ): Observable<RecourseBookingDto> {
    return this.updateRecourseBookingDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<RecourseBookingDto>): RecourseBookingDto => r.body),
    );
  }

  /** Path part for operation `getAllRecourseBookings()` */
  static readonly GetAllRecourseBookingsPath = '/service/v1/recoursebooking';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllRecourseBookings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllRecourseBookings$Response(
    params?: GetAllRecourseBookings$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<RecourseBookingDto>>> {
    return getAllRecourseBookings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllRecourseBookings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllRecourseBookings(
    params?: GetAllRecourseBookings$Params,
    context?: HttpContext,
  ): Observable<Array<RecourseBookingDto>> {
    return this.getAllRecourseBookings$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RecourseBookingDto>>): Array<RecourseBookingDto> => r.body),
    );
  }

  /** Path part for operation `createNewRecourseBooking()` */
  static readonly CreateNewRecourseBookingPath = '/service/v1/recoursebooking';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createNewRecourseBooking()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createNewRecourseBooking$Response(
    params: CreateNewRecourseBooking$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<{}>> {
    return createNewRecourseBooking(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createNewRecourseBooking$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createNewRecourseBooking(params: CreateNewRecourseBooking$Params, context?: HttpContext): Observable<{}> {
    return this.createNewRecourseBooking$Response(params, context).pipe(map((r: StrictHttpResponse<{}>): {} => r.body));
  }

  /** Path part for operation `startApprovalForNewRecourseBooking()` */
  static readonly StartApprovalForNewRecourseBookingPath = '/service/v1/recoursebooking/startApproval/new';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startApprovalForNewRecourseBooking()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  startApprovalForNewRecourseBooking$Response(
    params: StartApprovalForNewRecourseBooking$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<{}>> {
    return startApprovalForNewRecourseBooking(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `startApprovalForNewRecourseBooking$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  startApprovalForNewRecourseBooking(
    params: StartApprovalForNewRecourseBooking$Params,
    context?: HttpContext,
  ): Observable<{}> {
    return this.startApprovalForNewRecourseBooking$Response(params, context).pipe(
      map((r: StrictHttpResponse<{}>): {} => r.body),
    );
  }

  /** Path part for operation `rewriteSignature()` */
  static readonly RewriteSignaturePath = '/service/v1/recoursebooking/rewriteSignature';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rewriteSignature()` instead.
   *
   * This method doesn't expect any request body.
   */
  rewriteSignature$Response(
    params: RewriteSignature$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<{}>> {
    return rewriteSignature(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rewriteSignature$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rewriteSignature(params: RewriteSignature$Params, context?: HttpContext): Observable<{}> {
    return this.rewriteSignature$Response(params, context).pipe(map((r: StrictHttpResponse<{}>): {} => r.body));
  }

  /** Path part for operation `approveAllAutomatedRecourseBookings()` */
  static readonly ApproveAllAutomatedRecourseBookingsPath =
    '/service/v1/recoursebooking/approveAllAutomatedRecourseBookings';

  /**
   * Approve all bookings in state "IN APPROVAL" and type "Recourse(1)".
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `approveAllAutomatedRecourseBookings()` instead.
   *
   * This method doesn't expect any request body.
   */
  approveAllAutomatedRecourseBookings$Response(
    params?: ApproveAllAutomatedRecourseBookings$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<number>>> {
    return approveAllAutomatedRecourseBookings(this.http, this.rootUrl, params, context);
  }

  /**
   * Approve all bookings in state "IN APPROVAL" and type "Recourse(1)".
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `approveAllAutomatedRecourseBookings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  approveAllAutomatedRecourseBookings(
    params?: ApproveAllAutomatedRecourseBookings$Params,
    context?: HttpContext,
  ): Observable<Array<number>> {
    return this.approveAllAutomatedRecourseBookings$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<number>>): Array<number> => r.body),
    );
  }

  /** Path part for operation `startApprovalForAftersalesBookings()` */
  static readonly StartApprovalForAftersalesBookingsPath =
    '/service/v1/recoursebooking/approveAllAutomatedAftersalesBookings';

  /**
   * Approve all bookings in state "IN APPROVAL" and type "Aftersales(4)".
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startApprovalForAftersalesBookings()` instead.
   *
   * This method doesn't expect any request body.
   */
  startApprovalForAftersalesBookings$Response(
    params?: StartApprovalForAftersalesBookings$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<number>>> {
    return startApprovalForAftersalesBookings(this.http, this.rootUrl, params, context);
  }

  /**
   * Approve all bookings in state "IN APPROVAL" and type "Aftersales(4)".
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `startApprovalForAftersalesBookings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  startApprovalForAftersalesBookings(
    params?: StartApprovalForAftersalesBookings$Params,
    context?: HttpContext,
  ): Observable<Array<number>> {
    return this.startApprovalForAftersalesBookings$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<number>>): Array<number> => r.body),
    );
  }

  /** Path part for operation `setToBooked()` */
  static readonly SetToBookedPath = '/service/v1/recoursebooking/{recourseBookingId}/setBooked';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setToBooked()` instead.
   *
   * This method doesn't expect any request body.
   */
  setToBooked$Response(params: SetToBooked$Params, context?: HttpContext): Observable<StrictHttpResponse<{}>> {
    return setToBooked(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setToBooked$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setToBooked(params: SetToBooked$Params, context?: HttpContext): Observable<{}> {
    return this.setToBooked$Response(params, context).pipe(map((r: StrictHttpResponse<{}>): {} => r.body));
  }

  /** Path part for operation `startApproval()` */
  static readonly StartApprovalPath = '/service/v1/recoursebooking/startapproval/{recourseBookingId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startApproval()` instead.
   *
   * This method doesn't expect any request body.
   */
  startApproval$Response(params: StartApproval$Params, context?: HttpContext): Observable<StrictHttpResponse<{}>> {
    return startApproval(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `startApproval$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  startApproval(params: StartApproval$Params, context?: HttpContext): Observable<{}> {
    return this.startApproval$Response(params, context).pipe(map((r: StrictHttpResponse<{}>): {} => r.body));
  }

  /** Path part for operation `reprocessRecourseBooking()` */
  static readonly ReprocessRecourseBookingPath = '/service/v1/recoursebooking/reprocess/{recourseBookingId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reprocessRecourseBooking()` instead.
   *
   * This method doesn't expect any request body.
   */
  reprocessRecourseBooking$Response(
    params: ReprocessRecourseBooking$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<{}>> {
    return reprocessRecourseBooking(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reprocessRecourseBooking$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reprocessRecourseBooking(params: ReprocessRecourseBooking$Params, context?: HttpContext): Observable<{}> {
    return this.reprocessRecourseBooking$Response(params, context).pipe(map((r: StrictHttpResponse<{}>): {} => r.body));
  }

  /** Path part for operation `cancelBooking()` */
  static readonly CancelBookingPath = '/service/v1/recoursebooking/cancelbooking/{recourseBookingId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelBooking()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelBooking$Response(params: CancelBooking$Params, context?: HttpContext): Observable<StrictHttpResponse<{}>> {
    return cancelBooking(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cancelBooking$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelBooking(params: CancelBooking$Params, context?: HttpContext): Observable<{}> {
    return this.cancelBooking$Response(params, context).pipe(map((r: StrictHttpResponse<{}>): {} => r.body));
  }

  /** Path part for operation `approveRejectRecourseBooking()` */
  static readonly ApproveRejectRecourseBookingPath = '/service/v1/recoursebooking/approve/{recourseBookingId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `approveRejectRecourseBooking()` instead.
   *
   * This method doesn't expect any request body.
   */
  approveRejectRecourseBooking$Response(
    params: ApproveRejectRecourseBooking$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<{}>> {
    return approveRejectRecourseBooking(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `approveRejectRecourseBooking$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  approveRejectRecourseBooking(params: ApproveRejectRecourseBooking$Params, context?: HttpContext): Observable<{}> {
    return this.approveRejectRecourseBooking$Response(params, context).pipe(
      map((r: StrictHttpResponse<{}>): {} => r.body),
    );
  }

  /** Path part for operation `getRecourseBookingReferenceBookings()` */
  static readonly GetRecourseBookingReferenceBookingsPath =
    '/service/v1/recoursebooking/{referencedBookingId}/referencebookings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRecourseBookingReferenceBookings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRecourseBookingReferenceBookings$Response(
    params: GetRecourseBookingReferenceBookings$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<RecourseBookingDto>>> {
    return getRecourseBookingReferenceBookings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRecourseBookingReferenceBookings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRecourseBookingReferenceBookings(
    params: GetRecourseBookingReferenceBookings$Params,
    context?: HttpContext,
  ): Observable<Array<RecourseBookingDto>> {
    return this.getRecourseBookingReferenceBookings$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RecourseBookingDto>>): Array<RecourseBookingDto> => r.body),
    );
  }

  /** Path part for operation `getRecourseBookingPendingApprovals()` */
  static readonly GetRecourseBookingPendingApprovalsPath = '/service/v1/recoursebooking/pendingapprovals';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRecourseBookingPendingApprovals()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRecourseBookingPendingApprovals$Response(
    params?: GetRecourseBookingPendingApprovals$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<RecourseBookingDto>>> {
    return getRecourseBookingPendingApprovals(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRecourseBookingPendingApprovals$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRecourseBookingPendingApprovals(
    params?: GetRecourseBookingPendingApprovals$Params,
    context?: HttpContext,
  ): Observable<Array<RecourseBookingDto>> {
    return this.getRecourseBookingPendingApprovals$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RecourseBookingDto>>): Array<RecourseBookingDto> => r.body),
    );
  }
}

// #continue-sonar#
